import { render } from "./RequisitesDeviceChangeCheckDescription.vue?vue&type=template&id=1927bb08&ts=true"
import script from "./RequisitesDeviceChangeCheckDescription.vue?vue&type=script&lang=ts"
export * from "./RequisitesDeviceChangeCheckDescription.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__